export const WORD_CLOUD_PALETTES = [
    { value: "default", label: "Predeterminada", colors: ["#2f7ed8", "#0d233a", "#8bbc21", "#910000", "#1aadce", "#492970", "#f28f43", "#77a1e5", "#c42525", "#a6c96a"] },
    { value: "blues", label: "Azules", colors: ["#08306b", "#08519c", "#2171b5", "#4292c6", "#6baed6"] },
    { value: "warm", label: "Cálida", colors: ["#9e0142", "#d53e4f", "#f46d43", "#c65d18", "#8c510a"] },
    { value: "nature", label: "Naturaleza", colors: ["#00441b", "#006d2c", "#238b45", "#41ab5d", "#517c16"] },
    { value: "brand", label: "Alfadatizando", colors: ["#0d3656", "#ce5c30", "#216b85", "#9c4022", "#52778e"] },
];

export const WORD_CLOUD_ORIENTATIONS = [
    { value: "mixed", label: "Horizontal y vertical", rotation: { from: 0, to: 90, orientations: 2 } },
    { value: "horizontal", label: "Horizontal", rotation: { from: 0, to: 90, orientations: 1 } },
    { value: "vertical", label: "Vertical", rotation: { from: 90, to: 180, orientations: 1 } },
    { value: "diagonal", label: "Horizontal y diagonales", rotation: { from: -45, to: 45, orientations: 3 } },
];

export const DEFAULT_WORD_CLOUD_APPEARANCE = {
    colorPalette: "default",
    minFontSize: 10,
    maxFontSize: 60,
    orientation: "mixed",
};

export const getWordCloudAppearance = (configuration = {}) => {
    const size = (value, fallback) => Number.isFinite(Number(value)) && Number(value) > 0
        ? Math.min(200, Math.max(1, Math.round(Number(value)))) : fallback;
    const minFontSize = size(configuration.minFontSize, DEFAULT_WORD_CLOUD_APPEARANCE.minFontSize);
    const maxFontSize = Math.max(minFontSize, size(configuration.maxFontSize, DEFAULT_WORD_CLOUD_APPEARANCE.maxFontSize));
    return {
        colorPalette: WORD_CLOUD_PALETTES.some((palette) => palette.value === configuration.colorPalette)
            ? configuration.colorPalette : DEFAULT_WORD_CLOUD_APPEARANCE.colorPalette,
        orientation: WORD_CLOUD_ORIENTATIONS.some((orientation) => orientation.value === configuration.orientation)
            ? configuration.orientation : DEFAULT_WORD_CLOUD_APPEARANCE.orientation,
        minFontSize,
        maxFontSize,
    };
};

export const buildWordCloudSeriesAppearance = (configuration) => {
    const appearance = getWordCloudAppearance(configuration);
    return {
        colors: [...WORD_CLOUD_PALETTES.find((palette) => palette.value === appearance.colorPalette).colors],
        colorByPoint: true,
        minFontSize: appearance.minFontSize,
        maxFontSize: appearance.maxFontSize,
        rotation: { ...WORD_CLOUD_ORIENTATIONS.find((orientation) => orientation.value === appearance.orientation).rotation },
    };
};
